<template>
  <div class="locale-changer">
    <a
      v-for="lang in locales"
      :key="`language-${lang.value}`"
      class="locale-changer__link"
      :class="{
        'locale-changer__link--monochrome': monochrome,
        'locale-changer__link--selected': lang.value === currentLocale
      }"
      @click.prevent="changeLanguage(lang.value)"
    >
      {{ lang.name }}
    </a>
  </div>
</template>

<script lang="ts">
import moment from "moment"
import { mapMutations, mapState } from "vuex"

import { CHANGE_LANGUAGE } from "@/store/modules/common/mutationTypes.js"
import { ADS_API, API } from "@/utils/http"

export default {
  name: "LanguageSwitcher",

  props: {
    monochrome: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState("common", {
      currentLocale: (state: any): string => state.currentLocale,
      locales: (state: any): any => state.locales
    })
  },

  methods: {
    ...mapMutations("common", [CHANGE_LANGUAGE]),

    changeLanguage(value): void {
      if (value !== this.currentLocale) {
        // i18n
        this.$i18n.locale = value

        // moment
        moment.locale(value)

        // Set in store
        this[CHANGE_LANGUAGE](value)
        API.defaults.headers["Accept-Language"] = value
        ADS_API.defaults.headers["Accept-Language"] = value
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.locale-changer {
  display: flex;

  &__link {
    color: $brand-color-6;
    padding: 0 8px;
    cursor: pointer;

    &--monochrome {
      color: rgba(0, 0, 0, 0.25);
      &:first-child {
        border-right: 1px solid rgba(0, 0, 0, 0.25);
        padding-left: 0;
      }
      &:hover {
        color: rgba(0, 0, 0, 0.6);
      }
    }

    &--selected {
      color: #595959;
    }
  }
}
</style>
